import { render, staticRenderFns } from "./ObjectsGroupsTable.vue?vue&type=template&id=a9236198&scoped=true"
import script from "./ObjectsGroupsTable.vue?vue&type=script&lang=ts"
export * from "./ObjectsGroupsTable.vue?vue&type=script&lang=ts"
import style0 from "./ObjectsGroupsTable.vue?vue&type=style&index=0&id=a9236198&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9236198",
  null
  
)

export default component.exports